import React from 'react';
import classNames from 'classnames';
import { Checkbox } from 'antd';
import './driver-row.scss';
import { BringgFontIcons, BringgIcon } from '@bringg/bringg-icons';

type CheckboxChangeEvent = Parameters<React.ComponentProps<typeof Checkbox>['onChange']>[0];

interface Props {
	isChecked: boolean;
	onCheck: (e: CheckboxChangeEvent) => void;
	name: string;
	indeterminate?: boolean;
	isExpanded?: boolean;
	style?: React.CSSProperties;
}

const DriverRow: React.FC<Props> = ({ isChecked, onCheck, name, indeterminate, isExpanded, style }) => {
	return (
		<div className="driver-row" style={style}>
			<div className="checkbox-container">
				<Checkbox
					checked={isChecked}
					indeterminate={indeterminate}
					onClick={stopPropagation}
					onChange={onCheck}
					className="driver-row-checkbox"
					data-test-id="driver-row-checkbox-input"
				/>
			</div>
			<div className="name">
				<BringgIcon
					iconName={BringgFontIcons.ChevronRight}
					className={classNames({ 'is-expanded': isExpanded })}
				/>
				<span>{name}</span>
			</div>
		</div>
	);
};

const stopPropagation = e => {
	e.stopPropagation();
};

export default DriverRow;
